import React, { Component } from "react";
import { ConsumidoresFinales } from "./components/ConsumidoresFinales";
import "./styles/ConsumidoresFinales.css";

export default class ConsumidoresFinalesTab extends Component {
    render() {
        return <ConsumidoresFinales />;
    }
}
